export default __webpack_public_path__ + "static/0024-ddbe5e9b76d3b415629e0052b52e0ef2.png";